import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Divider from '@zenbusiness/zui/Divider';
import Heading from '@zenbusiness/zui/Heading';

import { FaqItem } from './components/FaqItem';
import * as Styled from './FaqsSection.style';

import { useProductLandingContext } from '../../contexts/useProductLanding';

function FaqsSection() {
  const { productConfig } = useProductLandingContext();
  const {
    faqs: { title, items = [], hideDividerBefore, disableItemGutters } = {},
    howItWorks,
    whatsIncluded,
    socialProof,
  } = productConfig;

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      {(howItWorks || whatsIncluded || socialProof) && !hideDividerBefore && <Divider />}
      <Styled.Root>
        {title && (
          <Styled.TitleContainer>
            <Heading size="xl" width={{ xs: '100%', lg: '50%' }}>
              <FormattedMessage id={title} />
            </Heading>
          </Styled.TitleContainer>
        )}
        <Styled.ItemsContainer gap={2}>
          {items?.map((item) => (
            <FaqItem key={item.question} item={item} disableGutters={disableItemGutters} />
          ))}
        </Styled.ItemsContainer>
      </Styled.Root>
    </>
  );
}

export default FaqsSection;
